// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"AttachmentsDialog_ellipsis__34CGA"};